<h3 mat-dialog-title class="title">
    Offer Status
</h3>
<mat-progress-bar *ngIf="offerForm?.disabled" mode="indeterminate"></mat-progress-bar>

<mat-dialog-content class="pr-0 pb-0 dialog-body">
    <form [formGroup]="offerForm">
        <div class="dialog-body flex-row">
            <div class="flex-row flex-100">
                <div class="flex-col flex-100">
                    <nova-am-submittal-send-to-client-info-card [model]="viewModel" [labelFlex]="labelFlex"
                        [dataFlex]="dataFlex" [infoBubbleNote]="facilityPermBillingInformation$ | async">
                    </nova-am-submittal-send-to-client-info-card>
                    <div class="flex-row block pt-0" *ngIf="viewModel.displayOfferStatusSelection">
                        <div class="nova__label flex-25">Offer Status*</div>
                        <div class="flex-80">
                            <mat-radio-group ngDefaultControl label="Offer Status*" name="offerStatus"
                                formControlName="offerStatus" data-qa-id="perm_offer_modal_status_radio_group">
                                <mat-radio-button *ngFor="let offerStatus of permanentJobOfferStatusOptions"
                                    [value]="offerStatus.status" class="mx-2"
                                    color="primary">{{offerStatus?.value}}</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <div class="flex-row block center-datapicker-line">
                        <div class="nova__label flex-25">Offer Date*</div>
                        <mat-form-field data-qa-id="perm_offer_modal_offer_date_form_field">
                            <input matInput placeholder="Select Offer Date" [matDatepicker]="offerDatePicker"
                                formControlName="offerDate" class="post-offer-modal-field">
                            <mat-datepicker-toggle matSuffix [for]="offerDatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #offerDatePicker></mat-datepicker>
                            <mat-error class="subtext" *ngIf="offerDateControl?.invalid">{{offerDateError}}</mat-error>
                        </mat-form-field>
                    </div>

                    <ng-container *ngIf="!showRemovalView">
                        <div class="flex-row block center-datapicker-line">
                            <div class="nova__label flex-25">Billing Amount*</div>
                            <mat-form-field data-qa-id="perm_offer_modal_billing_amount_form_field">
                                <span matPrefix>$ &nbsp;</span>
                                <input matInput type="number" placeholder="Enter Billing Amount"
                                    formControlName="billingAmount" (keypress)="checkChar($event)"
                                    (blur)="onBlur($event)" class="post-offer-modal-field">
                                <mat-error class="subtext"
                                    *ngIf="billingAmountControl?.invalid">{{billingAmountError}}</mat-error>
                                <mat-hint class="subtext" *ngIf="!billingAmountControl?.invalid">ex:
                                    100.00</mat-hint>
                            </mat-form-field>
                        </div>

                        <div class="flex-row block center-datapicker-line">
                            <div class="nova__label flex-25">Start Date*</div>
                            <mat-form-field data-qa-id="perm_offer_modal_start_date_form_field">
                                <input matInput placeholder="Select Start Date" [matDatepicker]="startDatePicker"
                                    formControlName="startDate" [min]="offerDateControl?.value"
                                    class="post-offer-modal-field">
                                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #startDatePicker></mat-datepicker>
                                <mat-error class="subtext"
                                    *ngIf="startDateControl?.invalid">{{startDateError}}</mat-error>
                            </mat-form-field>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="showRemovalView">
                        <div class="flex-row flex-order-7 block pt-0 no-bottom">
                            <div class="nova__label combobox-label flex-25">Removal Reason*</div>
                            <div class="flex-75">
                                <mat-form-field
                                    class="app-form-field-with-border no-mat-form-field-padding combobox-field"
                                     data-qa-id="perm_offer_modal_removal_reason_form_field">
                                    <mat-select formControlName="removalReason" panelClass="combobox-taller-panel"
                                        placeholder="Select a removal reason" class="post-offer-modal-field">
                                        <mat-option *ngFor="let reason of offerDeclinedRemovalReasons$ | async"
                                            [value]="reason">{{reason.removalReasonName}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </ng-container>

                    <div class="flex-row block">
                        <div class="nova__label flex-25">Live List Note<br />(optional)</div>
                        <div class="flex-75">
                            <div class="note-text-wrapper" [class.error]="noteError"
                                data-qa-id="perm_offer_modal_live_list_note_wrapper">
                                <textarea class="textarea" matInput formControlName="liveListNote" cdkTextareaAutosize
                                    cdkAutosizeMinRows="4">
                                </textarea>
                            </div>
                            <div class="character-count" [class.error]="noteError"
                                data-qa-id="perm_offer_modal_live_list_note_length_div">
                                {{noteLength}}/{{maxNoteLength}}
                            </div>
                        </div>
                    </div>
                    <div class="flex-row pt-0">
                        <div class="nova__label flex-25"></div>
                        <div class="flex-75">
                            <div>
                                <button id="update-status"  mat-flat-button
                                    [disabled]="offerForm?.invalid || offerForm?.disabled" color="primary"
                                    (click)="onSubmit()" data-qa-id="perm_offer_modal_update_button">
                                    UPDATE STATUS
                                </button>

                                <nova-am-submittal-status-update-cancel-button
                                    data-qa-id="perm_offer_modal_cancel_button" (clicked)="closeDialog()"
                                    #cancelButton></nova-am-submittal-status-update-cancel-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</mat-dialog-content>
